import Lookup from 'src/componentes/select2';

const ClassificacaoMOLookup = ({ clearable = false, ...rest }) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    url="/ClassificacaoMOLookup"
    clearable={clearable}
    {...rest}
  />
);

export default ClassificacaoMOLookup;
